import './status-pill.scss';

export const StatusPill = ({ type, children }) => (
  <span className={`status-pill status-pill--${type}`}>{children}</span>
);
